import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
import contactusImg from "../../assets/images/Contact/clay-banks-VK-podfv2DU-unsplash.jpg";
const useStyles = makeStyles((theme) => {
  return {
    mainAboutusContainer: {
      paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
      paddingRight: theme.spacing(myTheme.padding.right + 3.4),
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
    bCrumbLink: {
      "text-decoration": "none",
      "&:hover": {
        color: "black",
        "text-decoration": "none",
      },
    },
    firstContainer: {
      backgroundColor: "#fff",
      padding: 40,
      marginTop: 5,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding: 9,
      },
    },
    contactUsBoxesDiv: {
      display: "flex",
      paddingTop: 25,
      justifyContent: "space-between",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding: 2,
        paddingTop:15,
        flexDirection:'column'
      },
    },
    questionBox: {
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
      maxWidth: 370,
      padding: 15,
      alignItems: "center",
      paddingTop: 20,
      paddingBottom: 20,
      "&:hover": {
        boxShadow: " 0 3px 10px rgb(0 0 0 / 0.2);",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "100%",
        maxWidth: "100%",
        marginTop:5
      },
    },
    secondConatiner: {
      marginTop: 30,
      backgroundColor: "#fff",
      padding: 40,
      marginBottom: 30,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding: 9,
      },
    },
    imagecover: {
      width: "100%",
      height: 320,
      objectFit: "cover",
      backgroundImage: `url('${contactusImg}')`,
      backgroundRepeat: "no-repeat",
      backgroundColor:
        theme.palette.type === "light"
          ? theme.palette.grey[50]
          : theme.palette.grey[900],
      backgroundSize: "cover",
      backgroundPosition: "center",
      position: "relative",
    },
    layer: {
      backgroundColor: "rgba(255, 0, 0, 0.1)",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
  };
});

export default useStyles;
